import * as React from 'react';
import { Col, FormGroup, ControlLabel, Form, Button } from 'react-bootstrap';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { isRequired } from '../../../../../../util/validators';

interface IResetPasswordFormProps {
  actions: {
    push: (route: string) => void;
  };
}

class ResetPasswordForm extends React.Component<IResetPasswordFormProps> {
  public render() {
    const { handleSubmit } = this.props;

    return (
      <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
        <div className="blue-section-group">
          <div className="blue-section">
            <FormGroup controlId="email">
              <Col componentClass={ControlLabel} sm={3}>
                Registered email:
              </Col>
              <Col sm={5}>
                <Field
                  name="email"
                  type="email"
                  component={FieldFormControl}
                  validate={[isRequired]}
                />
              </Col>
            </FormGroup>
          </div>
          <div className="blue-section">
            <FormGroup controlId="dob">
              <Col componentClass={ControlLabel} sm={3}>
                Date of birth
              </Col>
              <Col sm={5}>
                <Field
                  name="dob"
                  type="masked-date"
                  component={FieldFormControl}
                  validate={[isRequired]}
                  placeholder="dd/mm/yyyy"
                />
              </Col>
            </FormGroup>
          </div>
          <div className="blue-section">
            <div className="margin-bottom">
              Your password must be a minimum of 8 characters long, with at least one
              lowercase, one uppercase letter, one special character and one number.
              <div style={{ margin: '5px 0', fontSize: '1em' }}>
                Please note if your password matches the above criteria it may be too obvious
                or include certain words that are not secure enough eg. Password!1 and we
                recommend trying a more unique password.
              </div>
            </div>
            <FormGroup controlId="password">
              <Col componentClass={ControlLabel} sm={3}>
                New Password:
              </Col>
              <Col sm={5}>
                <Field
                  name="password"
                  type="password"
                  component={FieldFormControl}
                  validate={[isRequired]}
                />
              </Col>
            </FormGroup>
            <FormGroup controlId="passwordConfirmation">
              <Col componentClass={ControlLabel} sm={3}>
                Confirm new password:
              </Col>
              <Col sm={5}>
                <Field
                  name="passwordConfirmation"
                  type="password"
                  component={FieldFormControl}
                  validate={[isRequired]}
                />
              </Col>
            </FormGroup>
          </div>
        </div>
        <div className="btn-bar">
          <Button
            bsStyle="primary"
            type="submit"
            className="pull-right"
          >
            LOGIN
          </Button>
        </div>
      </Form>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'reset_password',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('reset_password');

    return component;
  },
  connect(
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
])(ResetPasswordForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/scenes/ResetPassword/components/ResetPasswordForm/index.tsx